var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ArrowBtnNav',{class:{ hidden: _vm.isFirst && _vm.isLast },attrs:{"left-arrow-disabled":_vm.isFirst,"right-arrow-disabled":_vm.isLast,"inverted":_vm.inverted},on:{"onLeftClick":function($event){return _vm.$emit('prev')},"onRightClick":function($event){return _vm.$emit('next')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }